import { isDefined } from 'common/utils';

export const toQueryString = <T extends {}>(object: T): string => {
    return Object.entries(object)
        .filter(([, value]) => isDefined(value))
        .map(([key, value]) => `${key}=${encodeURIComponent(value as string | number | boolean)}`)
        .join('&');
};
